import domReady from '@wordpress/dom-ready';
import { large } from './../../settings';

domReady(() => {
	const popinsResa = document.querySelectorAll('.popin-resa');

	if (popinsResa && popinsResa.length) {
		popinsResa.forEach((block) => {
			let index = -1;

			const popinResaPreview = block.querySelector('.popin-preview');
			const popinResaNextview = block.querySelector('.popin-nextview');
			const popinResaItems = block.querySelectorAll('.popin-resa-item');
			const popinResaMenuItems = popinResaNextview
				? popinResaNextview.querySelectorAll('.menu-item')
				: [];
			const popinResaContents = popinResaNextview
				? popinResaNextview.querySelectorAll('.popin-content')
				: [];
			const popinResaContentsDom = block.querySelectorAll(
				'.popin-resa-item .item-content'
			);
			const popinResaClose = block.querySelector('.popin-close');
			const body = document.querySelector('body');

			const resetItems = () => {
				popinResaMenuItems.forEach((el) => {
					el.classList.remove('is-active');
				});
				popinResaContents.forEach((el) => {
					el.classList.remove('is-active');
				});
			};

			const activeItem = (i) => {
				index = i;
				resetItems();
				popinResaMenuItems[index].classList.add('is-active');
				popinResaContents[index].classList.add('is-active');
				const contentGrid =
					popinResaContents[index].querySelector('.activities-grid');

				if (contentGrid) {
					const contentGridItems = contentGrid.querySelectorAll(
						'.activities-grid-item'
					);
					if (contentGridItems && contentGridItems.length) {
						const elements = [
							'inner-icon',
							'inner-title',
							'inner-button-label',
							'inner-button',
							'inner-providers-label',
							'inner-providers-items',
						];

						elements.forEach((elementClass) => {
							const nodes = [...contentGridItems].map((item) => {
								return item.querySelector(
									`.item-inner .${elementClass}`
								);
							});

							const isLargeWindow = window.matchMedia(
								`(min-width: ${large}px)`
							).matches;

							if (isLargeWindow) {
								const elementMaxHeight = Math.max(
									...nodes.map((el) => el.offsetHeight)
								);

								nodes.forEach((el) => {
									el.style.minHeight = `${elementMaxHeight}px`;
								});
							} else {
								nodes.forEach((el) => {
									el.style.minHeight = `auto`;
								});
							}
						});
					}
				}
			};

			const closePopin = () => {
				block.classList.remove('is-visible');
				setTimeout(() => {
					body.classList.remove('is-freeze');
					if (popinResaPreview && popinResaNextview) {
						popinResaPreview.classList.remove('is-hidden');
						popinResaNextview.classList.remove('is-visible');
					}

					resetItems();
				}, 200);
			};

			if (popinResaItems && popinResaItems.length) {
				popinResaContentsDom.forEach((el, i) => {
					const content = el.innerHTML;
					popinResaContents[i].innerHTML = content;
				});

				popinResaItems.forEach((item, i) => {
					item.addEventListener('click', () => {
						popinResaPreview.classList.add('is-hidden');
						popinResaNextview.classList.add('is-visible');
						activeItem(i);
					});
				});

				popinResaMenuItems.forEach((item, i) => {
					item.addEventListener('click', () => {
						activeItem(i);
					});
				});
			}

			block.addEventListener('click', (e) => {
				if (e.target.classList.contains('popin-resa')) {
					closePopin();
				}
			});

			popinResaClose.addEventListener('click', () => {
				closePopin();
			});
		});
	}
});
